

export function clamp(num, min, max) {
    if(isNaN(num)) return min;
    return Math.min(Math.max(num, min), max);
}